// Module
var code = "<script>let $ctrl</script> <button class=\"button button--up\" type=\"button\" title=\"{{ $ctrl.title }}\" ng-click=\"$ctrl.up()\" ng-disabled=\"$ctrl.disabled\" name=\"button-up\"> <atom-text class=\"button__text\"> <ng-transclude></ng-transclude> </atom-text> <fa-icon class=\"button__icon\" icon=\"arrow-alt-up\"></fa-icon> </button> ";
// Exports
module.exports = code;